export default function PageNotFound(){
    return(
        <>Page Not Found</>
    )
}